import { useState } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import useDebounce from "../../hooks/useDebounce";
import { fetchAllFuel, useFuelHistory } from "../../hooks/useFuelAllowance";
import { exportExcelFromApi } from "../../utils/tools";
import FuelTabsHeader from "./FuelTabsHeader";
import FuelDateRange from "./FuelDateRange";
import { FuelExportButton, FuelSearchInput } from "./FuelToolbar";
import CheckinRegistrationTable from "../deviceManager/checkinRegistrationTable";
import { customDateFormatType } from "../../utils/utils";

// Xăng xe - tab Lịch sử: mỗi lần đổi loại (duyệt đơn / HCNS sửa trực tiếp)
const headers = [
  { label: "Thời gian", key: "createdAt", width: "11%" },
  { label: "Mã NV", key: "code", width: "8%" },
  { label: "Tên NV", key: "name", width: "14%" },
  { label: "Thay đổi", key: "change", width: "22%" },
  { label: "Cách đổi", key: "source", width: "13%" },
  { label: "Người thực hiện", key: "creator", width: "13%" },
  { label: "Ghi chú / lý do", key: "note", width: "17%" },
];

const exportMapping = {
  createdAt: "Thời gian",
  code: "Mã NV",
  name: "Tên NV",
  change: "Thay đổi",
  source: "Cách đổi",
  creator: "Người thực hiện",
  note: "Ghi chú / lý do",
};

const TableFuelHistory = ({ tab, setTab }) => {
  const [search, setSearch] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const debouncedSearch = useDebounce(search, 500);

  const filters = {
    search: debouncedSearch,
    fromDate: dateRange[0] ? customDateFormatType(dateRange[0]) : "",
    toDate: dateRange[1] ? customDateFormatType(dateRange[1]) : "",
  };

  const {
    items,
    refetch,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useFuelHistory(filters);

  const handleExport = () =>
    exportExcelFromApi({
      fetcher: () => fetchAllFuel("history", filters, exportMapping),
      mapping: exportMapping,
      filename: "lich_su_xang_xe.xlsx",
    });

  return (
    <>
      <FuelTabsHeader
        tab={tab}
        setTab={setTab}
        onRefresh={() => refetch()}
        rightSlot={<FuelExportButton onClick={handleExport} />}
      />

      <Box mt={{ base: "23px" }}>
        <Flex
          backgroundColor="var(--color-main)"
          borderRadius={{ base: "12px" }}
          flexDirection={"column"}
        >
          <Flex
            p={"16px 16px 12px 16px"}
            gap={{ base: "16px 32px" }}
            alignItems={"center"}
            flexWrap={"wrap"}
          >
            <FuelSearchInput
              onChange={(v) => {
                setSearch(v);
                setCurrentPage(1);
              }}
            />
            <FuelDateRange
              value={dateRange}
              placeholder="Ngày đổi từ ngày - đến ngày"
              onChange={(r) => {
                setDateRange(r);
                setCurrentPage(1);
              }}
            />
          </Flex>

          <CheckinRegistrationTable
            headers={headers}
            rows={items}
            renderCell={(key, row) => <Text>{row[key]}</Text>}
            isLoaded={!isLoading && !isRefetching}
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={(p) => setCurrentPage(p.selected + 1)}
            startEntry={startEntry}
            endEntry={endEntry}
            entries={entries}
          />
        </Flex>
      </Box>
    </>
  );
};

export default TableFuelHistory;
